import logo from "../../assets/lightconlogo(png  preto).png";
import "../../styles/style.css";
import { whatsappLink } from "../../utils/whatsapp";

export const HeaderComponent = () => {
    return (<header style={{ "backgroundColor": "#5f5f5f" }}>
        <div className="container-fluid">
            <div className="row">
                <div className="col-10">
                    <img className="ms-3 my-3" src={logo} alt="pictureNotFound" width={"25%"} />
                </div>
                <div className="col-2" style={{"marginTop": "2.5em"}}>
                    <a className="icon me-2" href="https://www.facebook.com/lightconsistemaconstrutivo/" target="_blank"><i className="fab fa-facebook"></i></a>
                    <a className="icon me-2" href="https://instagram.com/lightconbrasil" target="_blank"><i className="fab fa-instagram"></i></a>
                    <a className="icon" href={whatsappLink} target="_blank"><i className="fab fa-whatsapp"></i></a>
                </div>
            </div>
        </div>
    </header>);
}